import { useEffect, useState } from 'react'
import { RecipesRecipe } from '@mindfulchefuk/api-client'

import errorHandler from '@mindfulchefuk/utils/errorHandler'
import { APIRecipe } from '@mindfulchefuk/features/Recipes/interfaces'

interface RecipeData {
  recipe: APIRecipe
  isLoading: boolean
}

const useRecipeData = (
  recipeSlug: string | number,
  portionCount: string | number
): RecipeData => {
  const [recipe, setRecipe] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!portionCount) return

    const getRecipeData = async () => {
      setIsLoading(true)

      try {
        const response = await RecipesRecipe.select({
          recipes: [
            'allergens',
            'cuisine',
            'description',
            'key_ingredient_description',
            'title',
            'before_you_start',
          ],
          images: ['url'],
          recipe_portion_components: ['display_title'],
        })
          .includes([
            'images',
            'ingredients.allergen_presences',
            'steps',
            'macros_per_person_for_1_portion',
            'macros_per_person_for_2_portion',
            'macros_per_person_for_4_portion',
            'recipe_portion_components.component',
            'components.ingredient',
          ])
          .extraParams({ pagination_links: 'false' })
          .where({
            [Number(recipeSlug) ? 'id' : 'slug']: recipeSlug,
            images: { primary: true },
            recipe_portion_components: {
              portion_count_per_meal: portionCount,
            },
            allergen_presences: {
              contains: true,
            },
          })
          .find()

        setRecipe(response.data)
      } catch (err) {
        errorHandler(err)
      }

      setIsLoading(false)
    }

    getRecipeData()
  }, [recipeSlug, portionCount])

  return { recipe, isLoading }
}

export default useRecipeData
